import {
  CUSTOM_RANGE_TYPE,
  TODAY_TYPE,
  LAST_DAYS_TYPE,
  YESTERDAY_TYPE,
  LAST_MONTH_TYPE,
} from 'Constants/FormElement';

export const DATES = [
  {
    id: 1,
    tabHeading: 'Today',
    contentJSON: [],
    type: TODAY_TYPE,
  },
  {
    id: 2,
    tabHeading: 'Yesterday',
    contentJSON: [],
    type: YESTERDAY_TYPE,
  },
  {
    id: 3,
    tabHeading: 'Last 7 Days',
    contentJSON: [],
    type: LAST_DAYS_TYPE,
  },
  {
    id: 4,
    tabHeading: 'Last month',
    contentJSON: [],
    type: LAST_MONTH_TYPE,
  },
  
  {
    id: 5,
    tabHeading: 'Custom Range',
    contentJSON: [],
    type: CUSTOM_RANGE_TYPE,
  },
];
